import { render, staticRenderFns } from "./IntegralFlow.vue?vue&type=template&id=500c2700&scoped=true&"
import script from "./IntegralFlow.vue?vue&type=script&lang=js&"
export * from "./IntegralFlow.vue?vue&type=script&lang=js&"
import style0 from "./IntegralFlow.vue?vue&type=style&index=0&id=500c2700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500c2700",
  null
  
)

export default component.exports